import { useEffect } from 'react';
import { useAxios, usePrevious } from '@volta/utils/hooks';
// import { useVoltaAlert } from '@volta/context/Consumers';

export function useSurveyApprovalCount() {
  // const { openFailedAlert } = useVoltaAlert();
  const [apiFetch, apiLoading, apiStatus, apiResponse] = useAxios();
  // const prevApiStatus = usePrevious(apiStatus);

  const fetchData = () => {
    return apiFetch({
      id: 'getSurveyApprovalCount',
    });
  };

  // Commented to improve user experience in case this query is error
  // useEffect(() => {
  //   if (prevApiStatus !== undefined && prevApiStatus !== apiStatus) {
  //     if (apiStatus === 0 || (apiStatus === 1 && !apiResponse.data)) {
  //       openFailedAlert({
  //         description: 'Terjadi kesalahaan saat memuat data, harap coba lagi.',
  //       });
  //     }
  //   }
  // }, [apiStatus]);

  useEffect(() => {
    fetchData();
  }, []);

  const isDataLoaded = apiResponse && apiResponse.data;

  return {
    data: isDataLoaded ? apiResponse.data.surveyKms.totalCount : null,
    isLoading: apiLoading,
  };
}
